import { useTranslation } from 'react-i18next';
import { LogOut } from 'lucide-react';
import { DropdownMenu } from '@/components/ui/DropdownMenu';
import { useAuth } from '@/hooks/useAuth';
import { initials } from '@/utils/format';
import { roleLabel } from './role-label';

export function UserMenu() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <DropdownMenu
      label={t('user.menuFor', { name: `${user.firstName} ${user.lastName}` })}
      triggerClassName="gap-2.5"
      panelClassName="w-56 py-1"
      trigger={
        <>
          <span className="bg-brand-100 text-brand-700 grid size-9 shrink-0 place-items-center rounded-full text-sm font-semibold">
            {initials(user.firstName, user.lastName)}
          </span>
          <span className="hidden text-start sm:block">
            <span className="text-ink block max-w-32 truncate text-sm font-medium">
              {user.firstName} {user.lastName}
            </span>
            <span className="text-muted block max-w-32 truncate text-xs">
              {user.roles.map((role) => roleLabel(role, i18n.language)).join(', ') || user.email}
            </span>
          </span>
        </>
      }
    >
      {() => (
        <>
          <div className="border-line border-b px-3 py-2">
            <p className="text-ink truncate text-sm font-medium">{user.email}</p>
            {user.tenant ? (
              <p className="text-muted truncate text-xs">{user.tenant.name}</p>
            ) : (
              <p className="text-muted truncate text-xs">{t('nav.sections.platform')}</p>
            )}
          </div>

          <button
            type="button"
            role="menuitem"
            onClick={() => void logout()}
            className="hover:bg-canvas flex w-full items-center gap-2 px-3 py-2 text-start text-sm text-red-600"
          >
            <LogOut className="size-4 shrink-0" aria-hidden />
            {t('common.signOut')}
          </button>
        </>
      )}
    </DropdownMenu>
  );
}
